import styled from 'styled-components';

export const SocialIcon = styled.a`
  display: block;
`;

export const Icon = styled.img`
  display: block;
`;
